import type { InspectorAttribute } from '@/lib/apiTypes'
import { LockIcon } from '@/shared/components/Icons'
import { CopyButton } from '@/features/state/components/CopyButton'
import { maskSentinels } from '@/features/state/lib/inspector'

export function AttributeValue({ attr }: { attr: InspectorAttribute }) {
  if (attr.redacted) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <span style={{ fontFamily: 'var(--mono)', color: 'var(--text3)', letterSpacing: '0.08em' }}>••••••••</span>
        <span className="badge badge-neutral" style={{ fontSize: '0.55rem', color: 'var(--amber)', display: 'inline-flex', alignItems: 'center', gap: 3 }}>
          <LockIcon size={10} /> {attr.reason === 'sensitive' ? 'sensitive' : 'masked'}
        </span>
      </span>
    )
  }
  const v = attr.value
  if (v === null || v === undefined) return <span style={{ color: 'var(--text3)', fontFamily: 'var(--mono)' }}>null</span>
  if (typeof v === 'object') {
    const json = JSON.stringify(maskSentinels(v), null, 2)
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6 }}>
        <pre style={{ margin: 0, fontFamily: 'var(--mono)', fontSize: '0.68rem', color: 'var(--text2)', maxHeight: 200, overflow: 'auto', flex: 1 }}>{json}</pre>
        <CopyButton text={json} />
      </div>
    )
  }
  const s = String(v)
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text)', wordBreak: 'break-all' }}>{s}</span>
      <CopyButton text={s} />
    </span>
  )
}

